import { render, staticRenderFns } from "./cookie-category-translation-modal.vue?vue&type=template&id=d1c4fea8"
import script from "./cookie-category-translation-modal.vue?vue&type=script&lang=js"
export * from "./cookie-category-translation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports